import { gql } from "apollo-angular";

const PROMOTE_CROSS= gql`
mutation PromoteCrossReference(
  $fromProductId: Long!
  $toProductId: Long!
) {
  promoteCrossReference(
    promoteCrossReference: {
      fromProductId: $fromProductId
      toProductId: $toProductId
    }
  ) {
    id
    crossReferenceType
    crossReferenceDescription
  }
}
`;

export default PROMOTE_CROSS;